import RoomListModelBase from '../_generated/modelBases/room-list-model-base';

export default class RoomListModel extends RoomListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
